import { forwardRef } from "react";
import { FormControl } from "../FormControl";
import { useFormControlProps } from "../hooks";
import type { BaseFormProps } from "../types";
import type { BaseInputProps } from "./BaseInput";
import { BaseInput } from "./BaseInput";

export type InputProps = Omit<BaseInputProps, "name"> & BaseFormProps;

const InputInner = (props: InputProps, ref: React.ForwardedRef<HTMLInputElement>) => {
	const { formControlProps, errorAria, baseProps: inputProps } = useFormControlProps(props);
	return (
		<FormControl {...formControlProps}>
			<BaseInput {...(inputProps as BaseInputProps)} {...errorAria} ref={ref} onClear={props.onClear} />
		</FormControl>
	);
};

InputInner.displayName = "Input";

export const Input = forwardRef(InputInner);
